import React from "react";
import { List, ListItem, Divider } from "@material-ui/core";
import ChatContact from "./chatContact";

const ChatsList = ({ chats, selectedChatIndex, email, selectChat, newChat, setNewChatFormShow }) => {


  return (
    <div className="chatsList">
      <button className="new__btn" onClick={newChat}> New Chat</button>
      {chats.length > 0 && (
        <List className="list">
          {chats.map((c, i) => (
            <div key={i}>
               <a href="#chatView">
                <ListItem
                className="list__contact"
                onClick={() => {selectChat(i) ; setNewChatFormShow(false)}}
                selected={selectedChatIndex === i}
              >
                <ChatContact chat={c} userEmail={email} />
              </ListItem>
              </a>
              <Divider></Divider>
            </div>
          ))}
        </List>
      )}
    </div>
  );
};

export default ChatsList;
